module.exports = __webpack_public_path__ + "static/projects-6e261345bcd77035f1836d48ce885194.mp4";